import { render, staticRenderFns } from "./SliderNavigationArrows.vue?vue&type=template&id=da54364c&scoped=true&"
import script from "./SliderNavigationArrows.vue?vue&type=script&lang=js&"
export * from "./SliderNavigationArrows.vue?vue&type=script&lang=js&"
import style0 from "./SliderNavigationArrows.vue?vue&type=style&index=0&id=da54364c&lang=scss&"
import style1 from "./SliderNavigationArrows.vue?vue&type=style&index=1&id=da54364c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da54364c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('da54364c')) {
      api.createRecord('da54364c', component.options)
    } else {
      api.reload('da54364c', component.options)
    }
    module.hot.accept("./SliderNavigationArrows.vue?vue&type=template&id=da54364c&scoped=true&", function () {
      api.rerender('da54364c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ui/SliderNavigationArrows.vue"
export default component.exports